import { Component, OnInit, OnDestroy } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {CustomValidators} from 'ng2-validation';
import {Router} from '@angular/router';
import {Subscription} from 'rxjs/Subscription';
import {FooterNavbarService} from 'services/connectors/footer-navbar.service';
import {EmissionService} from 'services/emission.service';
import {Constants} from 'config/constants';
import {SpinnerService} from 'services/spinner.service';
import {BusinessFleetService} from 'services/calculator-items/business-fleet.service';

@Component({
  selector: 'tpc-fleet-boat',
  templateUrl: './fleet-boat.component.html',
  styleUrls: ['./fleet-boat.component.css']
})
export class FleetBoatComponent implements OnInit, OnDestroy {
    private nextSub: Subscription;
    private isFormSubmited = false;
    private gallonDefaultValue = 1;

    private _fuelTypes = {
        'diesel': 'Diesel',
        'ResidualFuelOil': 'Residual Fuel Oil'
    };

    private _form: FormGroup;

    constructor(private emissionService: EmissionService,
                private footerService: FooterNavbarService,
                private fleetService: BusinessFleetService,
                private router: Router,
                private fb: FormBuilder,
                private spinner: SpinnerService
    ) {
        this.nextSub = footerService.next$.subscribe(() => {
            this.isFormSubmited = true;
            if (this.form.status === 'VALID') {
                this.next();
            }
        });
        this.createForm();
    }

    ngOnInit() {
    }

    get form(): FormGroup {
        return this._form;
    }

    get fuelTypes(): Object {
        return this._fuelTypes;
    }

    private createForm() {
        this._form = this.fb.group({
            fuelType: ['', [Validators.required]],
            gallon: [this.gallonDefaultValue, [
                Validators.required,
                CustomValidators.min(1),
                CustomValidators.max(999999999999),
                CustomValidators.digits]],
        });
    }

    checkError(param) {
        return this.form.get(param).status === 'INVALID' && (this.isFormSubmited || this.form.get(param).touched);
    }

    next() {
        let calculatorName = Constants.calculators.business;
        let categoryName = 'fleet';
        let params = {
            fuelType: this.getFV('fuelType'),
            gallon: this.getFV('gallon'),
            vehicleType: this.router.url.split('/')[3]
        };

        this.spinner.show();
        this.emissionService.getEmissionValue(params, calculatorName, categoryName).subscribe(
            response => {
                let input = response.body[0].input[0];
                this.fleetService.addToVehicleList({
                    title: this.getTitleForVehicleList(params),
                    emission: input.emmission,
                    emissionTrees: input.emissionTrees,
                    DollarAmt: input.DollarAmt,
                    DollarAmtMonthly: input.DollarAmtMonthly
                });

                this.spinner.hide();
                this.router.navigate(['/business/fleet/list']);
            }
        );
    }

    private getTitleForVehicleList(params) {
        return `Boats: ${params.gallon + (params.gallon === '1' ? ' Gallon of' : ' Gallons of')} ${this.fuelTypes[params.fuelType]}`;
    }

    getFV(param) {
        return this.form.get(param).value;
    }

    ngOnDestroy () {
        if (this.nextSub) {
            this.nextSub.unsubscribe();
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/components/calculator/calculator-item/business-calculator/fleet/fleet-boat/fleet-boat.component.ts